import { SiteCreateMessage } from '../../core/site';
import { CreateTemplateMessage } from '../../core/template/template';

export class FormFields {
  public siteTitle: string;
  public siteTagline: string;
  public defaultDomain: string;
  public multisite: boolean;

  public buildSiteCreateMessage(accountGroupId: string, templateId?: string): SiteCreateMessage {
    const lowerDefaultDomain = this.defaultDomain ? this.defaultDomain.toLocaleLowerCase() : undefined;
    return new SiteCreateMessage(
      accountGroupId,
      this.siteTitle,
      this.siteTagline,
      lowerDefaultDomain,
      templateId,
      this.multisite,
    );
  }

  public buildTemplateCreateMessage(partnerId: string, parentTemplateId: string): CreateTemplateMessage {
    return new CreateTemplateMessage(this.siteTitle, this.defaultDomain, partnerId, parentTemplateId);
  }

  public populateFromSiteCreateMessage(site: SiteCreateMessage): void {
    this.siteTitle = site.siteTitle;
    this.siteTagline = site.siteTagline;
    this.defaultDomain = site.defaultDomain ? site.defaultDomain.toLowerCase() : site.defaultDomain;
    this.multisite = site.multisite;
  }

  public clean(): void {
    this.siteTitle = this.siteTitle ? this.siteTitle.trim() : undefined;
    this.siteTagline = this.siteTagline ? this.siteTagline.trim() : undefined;
    this.defaultDomain = this.defaultDomain ? this.defaultDomain.trim() : undefined;
    this.multisite = this.multisite ? this.multisite : false;
  }
}
